import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { EVENT_TYPE_ENUMS } from '../../events/events';

@Component({
  selector: 'app-pending-approval-item',
  templateUrl: './pending-approval-item.component.html',
  styleUrls: ['./pending-approval-item.component.scss'],
})
export class PendingApprovalItemComponent implements OnChanges {
  @Input() items;
  @Input() divider: { title: string; icon: string };
  @Input() collectionName: string;

  currentTime: Date = new Date();

  constructor(private router: Router) {}

  ngOnChanges(changes: SimpleChanges) {
    console.log('[PendingApprovalItem] Collection:', this.collectionName);
    console.log('[PendingApprovalItem] Items:', this.items);
    console.log('[PendingApprovalItem] Divider:', this.divider);
  }

  navigate(route) {
    this.router.navigate(route);
  }

  getDaysDiff(item) {
    const timeDiff = Math.abs(
      +this.currentTime / 1000 - item.createdAt?.seconds
    );
    return Math.ceil(timeDiff / (1000 * 3600 * 24));
  }

  getShortDate(item) {
    return item ? item.substr(0, 10) : '';
  }

  isExternallyHosted(event) {
    return (
      event.eventType === EVENT_TYPE_ENUMS.EXTERNALLY_HOSTED_AND_PAID ||
      event.eventType === EVENT_TYPE_ENUMS.EXTERNALLY_HOSTED_AND_FREE
    );
  }
}

